import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import '@splidejs/vue-splide/css/core'
import '@splidejs/vue-splide/css'
import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'
import 'vant/lib/index.css';

import * as fundebug from "fundebug-javascript";
import FundebugVue from "fundebug-vue";

fundebug.init({
    apikey: "69d511d382e65074f5a4228cf31c0cb2dde3d9ce5963238a2f5ef444f0e7fe53",
    silentConsole: true,
    silentDev:true,
    filters: [
        { message: /^Script error\.$/ },
        { message: /^Maximum call stack size exceeded\.$/ },
        { message: /^The user aborted a request\.$/ },
        {
            res: {
                status: /^0/
            }
        }
    ],
})

let app = createApp(App)
const store = createPinia()
store.use(piniaPluginPersist)

app.use(new FundebugVue(fundebug)).use(router).use(store).mount('#app')
